module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "form"
    }
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "RegisterForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "FormDiv"
  }, [_c('div', {
    staticClass: "FormsuaDiv"
  }, [_c('div', {
    staticClass: "getphone"
  }, [_c('span', [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.mobile),
      expression: "model.mobile"
    }],
    staticStyle: {
      "margin-top": "13px"
    },
    attrs: {
      "type": "tel",
      "placeholder": "请填写",
      "maxlength": "11",
      "minlength": "11",
      "name": "mobile",
      "id": "telphone"
    },
    domProps: {
      "value": (_vm.model.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "guestInfo"
  }, [_c('ul', [_c('li', [_c('label', [_c('span', [_vm._v(" 姓   名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "guestName",
    attrs: {
      "type": "text",
      "placeholder": "请填写",
      "maxlength": "8",
      "name": "name"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_c('span', [_vm._v("性   别")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.gender),
      expression: "model.gender"
    }],
    attrs: {
      "name": "gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("女")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("男")])]), _vm._v(" "), _c('a', {
    staticClass: "icon"
  })])]), _vm._v(" "), _c('li', [_c('label', [_c('span', [_vm._v(" 门   店")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.store),
      expression: "model.store"
    }],
    staticClass: "guestName",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "placeholder": "请填写",
      "maxlength": "8",
      "name": "store"
    },
    domProps: {
      "value": (_vm.model.store)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "store", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "remark-item"
  }, [_c('label', [_c('span', [_vm._v(" 备   注")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.remark),
      expression: "model.remark"
    }],
    staticStyle: {
      "max-height": "15rem",
      "resize": "none"
    },
    attrs: {
      "rows": "5",
      "placeholder": "请填写(必填)",
      "id": "remark",
      "name": "remark"
    },
    domProps: {
      "value": (_vm.model.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "remark", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pho"
  }, [_c('ImagesFile', {
    ref: "imageUrl",
    attrs: {
      "dataArray": _vm.model.imgUrl
    },
    model: {
      value: (_vm.model.imgUrl),
      callback: function($$v) {
        _vm.$set(_vm.model, "imgUrl", $$v)
      },
      expression: "model.imgUrl"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sumbitBtn"
  }, [_c('button', {
    staticClass: "default",
    attrs: {
      "type": "sumbit",
      "disabled": _vm.disabled
    }
  }, [_vm._v("提交")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("客户信息录入")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b1ecbac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/form.vue
// module id = 410
// module chunks = 1